import { Input, Button, List, Space, Row, Col, Select, Typography } from "antd";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { useState } from "react";
import { db } from "../../../firebase/config";
import { useAuthContext } from "../../../hooks/useAuthContext";

const { Text } = Typography;

export default function CreateUpdate() {
   const [header, setHeader] = useState("");
   const [inputs, setInputs] = useState([""]);
   const [data, setData] = useState([]);
   const [adminUpdate, setAdminUpdate] = useState(false);
   const [mainHeader, setMainHeader] = useState();

   const { user } = useAuthContext();

   const handleChange = (e, index) => {
      const newInputs = [...inputs];
      newInputs[index] = e.target.value;
      setInputs(newInputs);
   };

   const handleAddInput = () => {
      setInputs([...inputs, ""]);
   };

   const handleRemoveInput = (index) => {
      const newInputs = [...inputs];
      newInputs.splice(index, 1);
      setInputs(newInputs);
   };

   const handleSubmit = () => {
      setData([...data, { header, changes: inputs }]);
      setHeader("");
      setInputs([""]);
   };

   const handleRemoveUpdate = (index) => {
      const newData = [...data];
      newData.splice(index, 1);
      setData(newData);
   };

   const sendToDb = () => {
      const updateRef = collection(db, "latestUpdates");
      try {
         addDoc(updateRef, {
            date: serverTimestamp(),
            adminUpdate: adminUpdate,
            mainHeader: mainHeader,
            update: data,
            userPhoto: user.photoURL,
            userEmail: user.email,
            uid: user.uid,
         }).then(() => {
            alert("success");
         });
      } catch (error) {
         console.log(error.message);
      }
   };

   return (
      <div>
         <Space direction="vertical"></Space>

         <Row gutter={[10, 10]}>
            <Col span={24}>
               <Space>
                  <Text>Admin update?</Text>
                  <Select
                     defaultValue="no"
                     onChange={setAdminUpdate}
                     options={[
                        {
                           value: false,
                           label: "no",
                        },
                        {
                           value: true,
                           label: "yes",
                        },
                     ]}
                  />
               </Space>
            </Col>
            <Col span={24}>
               <Input value={mainHeader} onChange={(e) => setMainHeader(e.target.value)} placeholder="Update Main Header" />
            </Col>
            <Col span={24}>
               <Input value={header} onChange={(e) => setHeader(e.target.value)} placeholder="Update header" />
            </Col>
            <Col span={24}>
               {inputs.map((input, index) => (
                  <div key={index}>
                     <Input value={input} onChange={(e) => handleChange(e, index)} placeholder="Change" />
                     <Button onClick={() => handleRemoveInput(index)}>Remove</Button>
                  </div>
               ))}
            </Col>
            <Col span={12}>
               <Button onClick={handleAddInput}>Add Change</Button>
            </Col>
            <Col span={12}>
               <Space>
                  <Button block type="primary" onClick={handleSubmit}>
                     Add Update
                  </Button>
                  <Button block type="primary" danger onClick={sendToDb}>
                     Send to database
                  </Button>
               </Space>
            </Col>
         </Row>

         <List
            dataSource={data}
            renderItem={(update, index) => (
               <List.Item>
                  <List.Item.Meta
                     title={<b>{update.header}</b>}
                     description={
                        <ul>
                           {update.changes.map((change, idx) => (
                              <li key={idx}>{change}</li>
                           ))}
                        </ul>
                     }
                  />

                  <Button onClick={() => handleRemoveUpdate(index)}>Remove</Button>
               </List.Item>
            )}
         />
      </div>
   );
}
